export class SationImpactColor {
  static readonly MaterialCost = new SationImpactColor('MaterialCost', '#1291E9');
  static readonly InitialTransportCost = new SationImpactColor('InitialTransportCost', '#E69B10');
  static readonly MaterialMakingCost = new SationImpactColor('MaterialMakingCost', '#FFCC00');
  static readonly BuildTransportCostIn = new SationImpactColor('BuildTransportCostIn', '#000000');
  static readonly WorkingCost = new SationImpactColor('WorkingCost', '#0000FF');
  static readonly BuildTransportCostOut = new SationImpactColor('BuildTransportCostOut', '#00FF00');
  static readonly TotalCost = new SationImpactColor('TotalCost', '#00FF00');
  static readonly TotalCostEN = new SationImpactColor('TotalCostEN', '#70ad47');
  static readonly TotalCostCO = new SationImpactColor('TotalCostCO', '#4472c4');
  static readonly NaturalAggregates = new SationImpactColor('NaturalAggregates', '#1291E9');
  static readonly RecycledMaterials = new SationImpactColor('RecycledMaterials', '#E69B10');
  static readonly AsphaltAggregates = new SationImpactColor('AsphaltAggregates', '#FFCC00');
  static readonly ReusedSpoil = new SationImpactColor('ReusedSpoil', '#000000');

  // private to disallow creating other instances of this type
  private constructor(
    private readonly key: string,
    public readonly value: any
  ) {}

  toString() {
    return this.key;
  }
}
